import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../../components/Sidebar";
import Main from "./Main";
import Form from "./Form";

// Utils
import { getDataWithComp, getAlert } from "../../../../utils/SamuiUtils";
import { InitialDataTbSetColour } from "../../../../model/InitialData/InitialDataTbSetColour";

const TbSetColour = () => {
    const [mode, setMode] = useState("");
    const [dataMasterList, setDataMasterList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [formData, setFormData] = useState(InitialDataTbSetColour());

    useEffect(() => {
        const init = async () => {
            try {
                setMode("S");
                fetchRealtime();
            } catch (error) {
                getAlert("FAILED", error.message);
            }
        };
        init();
    }, []);

    const initialize = async () => {
        try {
            setMode("S");
            fetchRealtime();
        } catch (error) {
            getAlert("FAILED", error.message);
        }
    };

    const fetchRealtime = async () => {
        try {
            const masterList = await getDataWithComp(
                "Tb_Set_ItmColour",
                "Order By Colour_Code"
            );
            if (masterList && masterList.length > 0) {
                setDataMasterList(masterList);
            } else {
                setDataMasterList([]);
            }
        } catch (error) {
            getAlert("FAILED", error.message);
        }
    };

    const onPageInsert = () => {
        setMode("I");
    };

    const onRowSelected = (item) => {
        setMode("U");
        setFormData({
            comp_id: item.Comp_Id,
            Colour_Id: item.Colour_Id,
            Colour_Code: item.Colour_Code,
            Colour_Name: item.Colour_Name,
            Colour_Status: item.Colour_Status,
        });
        setSelectedData(item);
    };

    return (
        <div className="TbSetColour">
            <div className="wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="container">
                        <div className="page-inner">
                            {mode === "S" ? (
                                <Main
                                    masterList={dataMasterList}
                                    name={"ข้อมูลสี"}
                                    onPageInsert={() => onPageInsert()}
                                    onRowSelected={(item) => onRowSelected(item)}
                                />
                            ) : (
                                <Form
                                    callInitialize={initialize}
                                    mode={mode}
                                    name={"ข้อมูลสี"}
                                    formData={formData}
                                    setFormData={setFormData}
                                    selectedData={selectedData}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TbSetColour;
